"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuDivider = void 0;

var _style = _interopRequireDefault(require("styled-jsx/style"));

var _react = _interopRequireDefault(require("react"));

var MenuDivider = function MenuDivider() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "jsx-585623312"
  }, /*#__PURE__*/_react["default"].createElement(_style["default"], {
    id: "585623312"
  }, ["div.jsx-585623312{border-top:1px solid var(--card-border);margin:8px 0;}"]));
};

exports.MenuDivider = MenuDivider;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJNZW51RGl2aWRlciJdLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL01lbnUvTWVudURpdmlkZXIudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmV4cG9ydCBjb25zdCBNZW51RGl2aWRlcjogUmVhY3QuRkM8UmVhY3QuUHJvcHNXaXRoQ2hpbGRyZW48dW5rbm93bj4+ID0gKCkgPT4gKFxuICA8ZGl2PlxuICAgIDxzdHlsZSBqc3g+e2BcbiAgICAgIGRpdiB7XG4gICAgICAgIGJvcmRlci10b3A6IDFweCBzb2xpZCB2YXIoLS1jYXJkLWJvcmRlcik7XG4gICAgICAgIG1hcmdpbjogOHB4IDA7XG4gICAgICB9XG4gICAgYH08L3N0eWxlPlxuICA8L2Rpdj5cbik7XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUE7O0FBRU8sSUFBTUEsV0FBdUQsR0FBRyxTQUExREEsV0FBMEQ7RUFBQSxvQkFDckU7SUFBQTtFQUFBO0lBQUE7RUFBQSxpRkFEcUU7QUFBQSxDQUFoRSJ9